const checkRegionValue = (value, min, max) => {
    if (value < min || value > max) {
        return "deve essere compreso tra " + min + " e " + max;
    }
    return "";
}

const checkRegionYValue = (value, other, min, max) => {
    const tot = Math.abs(value - other);
    if(tot > 5) {
        return "Y massimo 5";
    }
    return checkRegionValue(value, min, max);
}

const checkRegionXValue = (value, other, min, max) => {
    const tot = Math.abs(value - other);
    if(tot > 4) {
        return "X massimo 4";
    }
    return checkRegionValue(value, min, max);
}

const checkCeilingHeight = (height) => {
    if ((height < 2) || (height > 3.5)) { // Vayyar nella documentazione (42017) dice max 3.0
        return "l'altezza deve essere fra 2 e 3.5";
    } else {
        return "";
    }
}

const checkWallHeight = (height)=> {
    if (height != 1.5) {
        return "l'altezza deve essere 1.5";
    } else {
        return "";
    }
}

export const checkValue = (object, value, Region, sensorMounting) => {
    const isCeiling = (sensorMounting === 2);
    switch (object) {
        case "xMin":
            return isCeiling ? checkRegionValue(value, -2, 0) : checkRegionXValue(value, Region.xMax, -3, 0);
        case "xMax":
            return isCeiling ? checkRegionValue(value, 0, 2) : checkRegionXValue(value, Region.xMin, 0, 2);
        case "yMin":
            return isCeiling ? checkRegionYValue(value, Region.yMax, -3, 0) : checkRegionValue(value, 0, 0);
        case "yMax":
            return isCeiling ? checkRegionYValue(value, Region.yMin, 0, 3) : checkRegionValue(value, 0.3, 4);
        case "zMin":
            return checkRegionValue(value, 0, 2);
        case "zMax":
            return checkRegionValue(value, 0, 2);
        case "sensorHeight":
            return isCeiling ? checkCeilingHeight(value) : checkWallHeight(value);
        default:
            return "";
    }
    return "";
};

export const checkSubregionValue = (object, subregion, Region) => {
    const value = parseFloat(subregion[object]);
    switch (object) {
        case "xMin":
            if (value < Region.xMin) {
                return "deve essere maggiore di xMin della regione " + Region.xMin;
            }
            if (value > Region.xMax) {
                return "deve essere minore di xMax della regione " + Region.xMax;
            }
            if (value >= subregion.xMax)  {
                return "deve essere minore di xMax";
            }
            break;
        case "xMax":
            if (value < Region.xMin) {
                return "deve essere maggiore di xMin della regione " + Region.xMin;
            }
            if (value > Region.xMax) {
                return "deve essere minore di xMax della regione " + Region.xMax;
            }
            if (value <= subregion.xMin)  {
                return "deve essere maggiore di xMin";
            }
            break;
        case "yMin":
            if (value < Region.yMin) {
                return "deve essere maggiore di yMin della regione " + Region.yMin;
            }
            if (value > Region.yMax) {
                return "deve essere minore di yMax della regione " + Region.yMax;
            }
            if (value >= subregion.yMax)  {
                return "deve essere minore di yMax";
            }
            break;
        case "yMax":
            if (value < Region.yMin) {
                return "deve essere maggiore di yMin della regione " + Region.yMin;
            }
            if (value > Region.yMax) {
                return "deve essere minore di yMax della regione " + Region.yMax;
            }
            if (value <= subregion.yMin)  {
                return "deve essere maggiore di yMin";
            }
            break;
        case "zMin":
            if (value < Region.zMin) {
                return "deve essere maggiore di zMin della regione " + Region.zMin;
            }
            if (value > Region.zMax) {
                return "deve essere minore di zMax della regione " + Region.zMax;
            }
            if (value >= subregion.zMax)  {
                return "deve essere minore di zMax";
            }
            break;
        case "zMax":
            if (value < Region.zMin) {
                return "deve essere maggiore di zMin della regione " + Region.zMin;
            }
            if (value > Region.zMax) {
                return "deve essere minore di zMax della regione " + Region.zMax;
            }
            if (value <= subregion.zMin)  {
                return "deve essere maggiore di zMin";
            }
            break;
        default:
            return "";
    }
    return "";
}

export const getMinMaxSensor45Ceiling = (min, max) => {
    // span is larger than 5, or min is less then -3, or max is higher then 3
    if (((max - min) > 5) || (min < -3) || (max > 3)) {
        return {
            result: false,
            sensorMin: -2.5,
            sensorMax: 2.5
        }
    }
    // normal setting
    if ((min >= -2.5) && (max <= 2.5)) {
        return {
            result: true,
            sensorMin: -2.5,
            sensorMax: 2.5
        }
    }
    if (min < -2.5) {
        return {
            result: true,
            sensorMin: min,
            sensorMax: min + 5
        }
    }
    if (max > 2.5) {
        return {
            result: true,
            sensorMin: max - 5,
            sensorMax: max
        }
    }
    return {
        result: false,
        sensorMin: -2.5,
        sensorMax: 2.5
    }
}

export const getMinMaxSensorWall = (min, max) => {
    // span is larger than 4, or min is less then -3, or max is higher then 2
    if (((max - min) > 4) || (min < -3) || (max > 2)) {
        return {
            result: false,
            sensorMin: -2,
            sensorMax: 2
        }
    }
    // normal setting
    if ((min >= -2) && (max <= 2)) {
        return {
            result: true,
            sensorMin: -2,
            sensorMax: 2
        }
    }
    if (min < -2) {
        return {
            result: true,
            sensorMin: min,
            sensorMax: min + 4
        }
    }
    return {
        result: false,
        sensorMin: -2,
        sensorMax: 2
    }
}

export const generateGridLines45Ceiling = (width, height, step, yTop, marginTop) => {
    const lines = [];

    let v = -2
    for (let x = 0; x <= width; x += step) {
        lines.push(
            <line
                key={`v-${x}`}
                x1={x}
                y1={0}
                x2={x}
                y2={height}
                stroke="gray"
                strokeDasharray={(v == 0) ? undefined : "4"}
                strokeWidth={(v == 0) ? "2" : "1"}
            />,
            <text
                key={`v-label-${x}`}
                x={x}
                y={10}
                fontSize="12"
                fill="black"
                textAnchor="end"
            >
                {v}
            </text>,
            v = v + 0.5
        );
    }

    let h = yTop;
    for (let y = 0; y <= height; y += step) {
        lines.push(
            <line
                key={`h-${y}`}
                x1={0}
                y1={y+marginTop}
                x2={width}
                y2={y+marginTop}
                stroke="gray"
                strokeDasharray={(h == 0) ? undefined : "4"}
                strokeWidth={(h == 0) ? "2" : "1"}
            />,
            <text
                key={`h-label-${y}`}
                x={10}
                y={y+marginTop}
                fontSize="12"
                fill="black"
                textAnchor="middle"
            >
                {h}
            </text>,
            h = h - 0.5
        );
    }

    return lines;
}

export const generateGridLinesWall = (width, height, step, xLeft, marginLeft) => {
    const lines = [];

    let v = xLeft
    for (let x = 0; x <= width; x += step) {
        lines.push(
            <line
                key={`v-${x}`}
                x1={x+marginLeft}
                y1={0}
                x2={x+marginLeft}
                y2={height}
                stroke="gray"
                strokeDasharray={(v == 0) ? undefined : "4"}
                strokeWidth={(v == 0) ? "2" : "1"}
            />,
            <text
                key={`v-label-${x}`}
                x={x+marginLeft}
                y={10}
                fontSize="12"
                fill="black"
                textAnchor="end"
            >
                {v}
            </text>,
            v = v - 0.5
        );
    }

    let h = 0;
    for (let y = 0; y <= height; y += step) {
        lines.push(
            <line
                key={`h-${y}`}
                x1={0}
                y1={y}
                x2={width}
                y2={y}
                stroke="gray"
                strokeDasharray={(h == 0) ? undefined : "4"}
                strokeWidth={(h == 0) ? "2" : "1"}
            />,
            <text
                key={`h-label-${y}`}
                x={10}
                y={y}
                fontSize="12"
                fill="black"
                textAnchor="middle"
            >
                {h}
            </text>,
            h = h + 0.5
        );
    }

    return lines;
}
